var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.052 2.47275C17.106 2.11725 16.9545 1.761 16.6613 1.55175C16.368 1.34325 15.9818 1.317 15.663 1.48425C13.1123 2.82375 4.18951 7.50825 1.44901 8.94675C1.11076 9.12375 0.911262 9.48525 0.940512 9.86551C0.969762 10.2458 1.22176 10.5728 1.58326 10.6965C2.65051 11.0618 3.95476 11.5095 6.00001 12.2108L14.25 4.5L7.57351 12.75C9.75451 13.4978 13.1648 14.667 14.0205 14.9603C14.2883 15.0525 14.5838 15.0203 14.826 14.874C15.0683 14.727 15.2325 14.4803 15.2753 14.1998L17.052 2.47275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62402 13.2173V15.6698C6.62402 16.0463 6.84527 16.3875 7.18802 16.5413C7.53152 16.6958 7.93277 16.6343 8.21402 16.3838L10.3425 14.4923L6.62402 13.2173Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic-send.812f8ad126cd021901df4aefe3e864cb.svg";
export { ForwardRef as ReactComponent };